import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import SectionTitle from '../crt/SectionTitle';
import Panel from '../crt/Panel';

const RevenueMetrics: React.FC = () => {
  return (
    <Box>
      <SectionTitle>REVENUE &amp; MONETIZATION</SectionTitle>

      <Alert severity="info" sx={{ mb: 3 }}>
        Revenue data will be available once YouTube Partner Program is approved and YouTube Reporting API reports start generating.
      </Alert>

      <Panel label="PENDING YOUTUBE PARTNER PROGRAM APPROVAL">
        <Typography color="textSecondary">
          Once approved, this section will display:
        </Typography>
        <ul>
          <li>Ad revenue by video and time period</li>
          <li>CPM (Cost Per Mille) trends</li>
          <li>Revenue by ad type (skippable, non-skippable, display)</li>
          <li>YouTube Premium revenue</li>
          <li>Channel memberships and Super Chat revenue</li>
          <li>Revenue by geography</li>
          <li>Estimated earnings projections</li>
        </ul>
      </Panel>
    </Box>
  );
};

export default RevenueMetrics;
